import type { ZodTypeAny, output } from 'zod';

import { AppError } from '../http/errors';

/**
 * Validates a raw transport response against a DTO schema and returns the parsed DTO.
 *
 * The schema's OUTPUT type is returned, so transforms (e.g. coerce id to string) are
 * applied. If the response shape does not match, throws AppError('server', …) so the UI
 * gets the same error contract as for any other failure.
 */
export function parseDto<Schema extends ZodTypeAny>(
  schema: Schema,
  raw: unknown,
  context: string,
): output<Schema> {
  const result = schema.safeParse(raw);
  if (!result.success) {
    throw new AppError({
      code: 'server',
      message: `Invalid response shape from ${context}`,
      details: { issues: result.error.flatten() },
    });
  }
  return result.data;
}
